<template>
	<div>
		<el-row :gutter="20">
			<el-col :span="6">
				<el-input placeholder="按名称搜索" v-model="keyword" maxlength="150">
					<i slot="prefix" class="el-input__icon el-icon-search"></i>
				</el-input>
			</el-col>
			<el-col :span="18">
				<el-button type="info" @click="search()">搜索</el-button>
				<el-button type="primary" @click="handleAdd">新建</el-button>
			</el-col>
		</el-row>
		<br />
		<el-table size="mini" v-loading="loading" :data="tableData" height="400" :row-class-name="tableRowClassName">
			<el-table-column type="index" label="序号" width="60"> </el-table-column>
			<el-table-column prop="name" label="名称"> </el-table-column>
			<el-table-column prop="max" label="最大值" width="70"> </el-table-column>
			<el-table-column prop="min" label="最小值" width="70"> </el-table-column>
			<el-table-column prop="avg" label="平均值" width="70"> </el-table-column>
			<el-table-column prop="unit" label="单位" width="60"> </el-table-column>
			<el-table-column prop="reserve" label="保留" width="80"> </el-table-column>
			<el-table-column label="编辑" width="160">
				<template slot-scope="scope">
					<el-button @click="handleEdit(scope.row)" icon="el-icon-edit" type="text">修改</el-button>
					<el-divider direction="vertical"></el-divider>
					<el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.row)">
						<el-button type="text" slot="reference" icon="el-icon-delete">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
			<el-table-column label="选择" width="110">
				<template slot-scope="scope">
					<el-button v-if="!teachIsSelected(scope.row)" icon="el-icon-circle-plus-outline" @click="handleSelect(scope.row)" type="text">选择</el-button>
					<el-button v-else @click="handleCancelSelect(scope.row)" icon="el-icon-remove-outline" type="text">取消选择</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 新增工艺参数  -->
		<el-dialog :title="formTitle" :visible.sync="dialogVisible" width="500px" append-to-body>
			<el-form :model="teachForm" ref="teachForm" :label-width="formLabelWidth" :rules="rules">
				<el-form-item label="名称" prop="name">
					<el-input v-model.trim="teachForm.name" autocomplete="off" placeholder="请输入工艺参数名称" maxlength="150" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="单位" prop="unit">
					<el-input v-model.trim="teachForm.unit" autocomplete="off" placeholder="请输入单位" maxlength="50" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="保留" prop="reserve">
					<el-input v-model.trim="teachForm.reserve" autocomplete="off" placeholder="请输入保留内容" maxlength="150" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="最大值" prop="max">
					<el-input-number v-model.trim="teachForm.max" :min="1" :max="99999" label="请输入最大值"></el-input-number>
				</el-form-item>
				<el-form-item label="最小值" prop="min">
					<el-input-number v-model.trim="teachForm.min" :min="1" :max="teachForm.max" label="请输入最小值"></el-input-number>
				</el-form-item>
				<el-form-item label="平均值" prop="avg">
					<el-input-number v-model.trim="teachForm.avg" :min="1" :max="99999" label="请输入平均值"></el-input-number>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onDialogCancel">取消</el-button>
				<el-button type="primary" @click="saveTeachInfo" :loading="saving">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { techInfoRequest, SaveTech } from '@/network/requests/techInfo'
	export default {
		data() {
			/**
			 * 工艺参数组重名检查。
			 * @param {*} rule
			 * @param {*} value
			 * @param {*} callback
			 */
			var validateTechNameExist = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入工艺名称'))
				} else {
					var msg = '工艺名称已经存在，请更换名称。'
					//检查名称是否重复。
					techInfoRequest.queryAll({ name: value }).then(res => {
						if (res.length > 1) {
							callback(new Error(msg))
						} else if (res.length == 1) {
							var data = res[0]
							if (this.teachForm._id) {
								if (data._id.$oid != this.teachForm._id.$oid) {
									callback(new Error(msg))
								} else {
									callback()
								}
							} else {
								callback(new Error(msg))
							}
						} else {
							callback()
						}
					})
				}
			}

			return {
				keyword: '',
				tableData: [],
				pageSize: 10,
				pageIndex: 1,
				totalCount: 0,
				totalPage: 0,
				loading: false,
				formLabelWidth: '80px',
				dialogVisible: false,
				teachForm: {
					max: 0,
					min: 0,
					avg: 0,
				},
				formTitle: '',
				saving: false,
				rules: {
					name: [{ validator: validateTechNameExist, trigger: 'blur' }],
					max: [{ required: true, message: '请输入最大值', trigger: 'blur' }],
					min: [{ required: true, message: '请输入最小值', trigger: 'blur' }],
					avg: [{ required: true, message: '请输入平均值', trigger: 'blur' }],
					unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
				},
			}
		},
		props: {
			groupName: {
				type: String,
				required: true,
			},
			teaches: {
				type: Array,
			},
		},
		methods: {
			/**
			 * 选中行，样式处理。
			 */
			tableRowClassName({ row, rowIndex }) {
				var first = this.teaches.find(t => t.tech_id == row._id.$oid)
				if (first) {
					return 'success-row'
				}
				return ''
			},
			/**
			 * 查询工艺。
			 */
			search() {
				this.pageIndex = 1
				this.loadData()
			},
			/**
			 * 获取查询条件。
			 */
			getQueryFilter() {
				if (this.keyword) {
					return {
						name: { $regex: this.keyword.trim() },
					}
				}

				return undefined
			},
			/**
			 * 加载工艺参数。
			 */
			loadData() {
				if (this.loading) {
					return
				}

				this.loading = true

				var filter = this.getQueryFilter()

				techInfoRequest
					.queryAll(filter)
					.then(res => {
						this.tableData = res
					})
					.finally(() => {
						this.loading = false
					})
			},
			/**
			 * 添加参数。
			 */
			handleAdd() {
				this.formTitle = '添加参数'
				this.dialogVisible = true
				this.teachForm = {
					max: 0,
					min: 0,
					avg: 0,
				}
			},
			/**
			 * 选择。
			 */
			handleSelect(row) {
				this.$emit('select', row)
			},
			/**
			 * 取消选择。
			 */
			handleCancelSelect(row) {
				this.$emit('remove', row)
			},
			/**
			 * 取消模态框。
			 */
			onDialogCancel() {
				this.dialogVisible = false
			},
			/**
			 * 保存工艺参数。
			 */
			saveTeachInfo() {
				if (this.saving) {
					return
				} else {
					this.saving = true
				}

				this.$refs['teachForm'].validate(valid => {
					if (valid) {
						SaveTech(this.teachForm).finally(() => {
							this.dialogVisible = false
							setTimeout(() => {
								this.saving = false
							}, 1000)

							this.loadData()
						})
					} else {
						console.log('error submit!!')
						this.saving = false
						return false
					}
				})
			},
			/**
			 * 删除工艺参数。
			 */
			handleDelete(row) {
				this.loading = true
				techInfoRequest.deleteById(row._id.$oid).finally(() => {
					this.loading = false
					this.loadData()
				})
			},
			/**
			 * 编辑工艺参数。
			 */
			handleEdit(row) {
				this.formTitle = '修改工艺参数'
				this.teachForm = { ...row }
				this.dialogVisible = true

				console.log('编辑工艺参数', this.teachForm)
			},
			/**
			 * 判断工艺参数是否被选中。
			 */
			teachIsSelected(row) {
				var teachId = row._id.$oid

				var selected = false
				for (var i = 0; i < this.teaches.length; i++) {
					var item = this.teaches[i]
					if (item.tech_id == teachId) {
						selected = true
						break
					}
				}

				return selected
			},
		},
		created() {
			console.log('selectedTeachIds', this.teaches)
			this.loadData(true)
		},
	}
</script>

<style></style>
